import React from "react";

import { serverUrl } from "../../config";

import GridItem from "../../partials/gridItem";
import { useNavigate } from "react-router-dom";
import { parseSummary } from "../../partials/posts/postHelpers";

export default function QuizItem(props) {
  const navigate = useNavigate();

  return (
    <GridItem
      xs={12}
      sm={6}
      md={3}
      itemClass="quiz"
      item={props.item}
      bundle={props.item?.bundle}
      id={props.item?.id}
      title={props.item?.title}
      field_body={parseSummary(props.item)}
      category_label={props.item.category_labels}
      created={props.item?.created}
      hasImg={true}
      imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
      alt={`Poster for test ${props.item?.id}`}
      cardActionArea={true}
      creator={props.creator}
      cardActionCallBack={
        props.creator ? () => {} : () => navigate(`/quizzes/${props.item?.id}`)
      }
      contentType={props.contentType}
    ></GridItem>
  );
}
